__turbopack_context__.v({
  "bodyText": "contentsampling-module-scss-module__1sufIa__bodyText",
  "container": "contentsampling-module-scss-module__1sufIa__container",
  "contentCard": "contentsampling-module-scss-module__1sufIa__contentCard",
  "contentCardEven": "contentsampling-module-scss-module__1sufIa__contentCardEven",
  "contentWrapper": "contentsampling-module-scss-module__1sufIa__contentWrapper",
  "headline": "contentsampling-module-scss-module__1sufIa__headline",
  "headlineText": "contentsampling-module-scss-module__1sufIa__headlineText",
  "hiddenDesktop": "contentsampling-module-scss-module__1sufIa__hiddenDesktop",
  "hiddenMobile": "contentsampling-module-scss-module__1sufIa__hiddenMobile",
  "hoverForeground": "contentsampling-module-scss-module__1sufIa__hoverForeground",
  "hoverLink": "contentsampling-module-scss-module__1sufIa__hoverLink",
  "imageLink": "contentsampling-module-scss-module__1sufIa__imageLink",
  "imageStyles": "contentsampling-module-scss-module__1sufIa__imageStyles",
  "lightTheme": "contentsampling-module-scss-module__1sufIa__lightTheme",
  "mediaElementSingle": "contentsampling-module-scss-module__1sufIa__mediaElementSingle",
  "modalBody": "contentsampling-module-scss-module__1sufIa__modalBody",
  "pingPong": "contentsampling-module-scss-module__1sufIa__pingPong",
  "reversed": "contentsampling-module-scss-module__1sufIa__reversed",
  "section": "contentsampling-module-scss-module__1sufIa__section",
  "spacing": "contentsampling-module-scss-module__1sufIa__spacing",
});
